/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 홍보 결과 추가 탭 컴포넌트
 * 버전 : 1.0
 * 파일명 : PromoResultAdd.ts
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2025-07-17, 강동형 : 저작권 추가, 레이아웃 일부 수정, 참여자 수 > 전체학생 유효성 검사 추가
 * ================================================================ 
 */

import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import {
  Box,
  TextField,
  Typography,
  IconButton,
} from '@mui/material';
import { PromoResultType } from 'src/pages/PromoResultPage';
import InputBoxOnChange from '../inputbox/InputBoxOnChange';
import { usePromoresultStore } from 'src/stores/PromoStore';
import DatePickerPromoResult from './DatePickerPromoResult';
import { AlertSpan, NextButton } from '../common/CommonStyled';
import ButtonResultAdd from './ButtonResultAdd';
import PromoAutoComplete from './PromoAutoComplete';
import { Icon_ArrowBack } from '../common/CommonIcons';


interface Props{
  setTab : React.Dispatch<React.SetStateAction<PromoResultType>>;
}

const Container = styled(Box)`
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100vh;
  ;
`;

const Label = styled(Typography)({
  color: '#7F7F89',
  fontSize: '14px',
  paddingBottom: '10px'
})

const NumberInputContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginTop: '10px'
})

const LargeTextField = styled(TextField)`
  height: '100%';
    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #39b95b;
    border-width: 2px;
  }
`;

const ButtonContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-Top:20px;
  gap: 10px;
  width: 100%;
`;

const Header = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center', // ✅ camelCase로 수정
  paddingBottom: '32px',
  fontSize:'18px',
  fontWeight:'bold'
});

const PromoResultAdd = ({setTab}:Props) => {
  const setField = usePromoresultStore((state)=>state.setField)
  const total_cnt = usePromoresultStore((state)=>state.total_cnt)
  const attendee_cnt = usePromoresultStore((state)=>state.attendee_cnt)
  const reset = usePromoresultStore((state)=>state.reset)
  const isAttendeeValid = (Number(total_cnt)>=Number(attendee_cnt)) ? true:false


  useEffect(()=>{
    reset()
    return ()=>{
      reset()
    }
  },[])

  return (
    <Container>
      <Header>
        <IconButton onClick={() => setTab('home')} sx={{position:'absolute', left:'10px'}}>
          <Icon_ArrowBack/>
        </IconButton>
        홍보 결과 기록
      </Header>
      <Label>*학교명</Label>
        <Box display="flex" alignItems="baseline" justifyContent="flex-end">
          <PromoAutoComplete/>
        </Box>
      <Label marginTop='10px'>*방문일</Label>
        <DatePickerPromoResult/>
      <Label marginTop='10px'>인원수</Label>
      <NumberInputContainer>
        <Label minWidth='110px'>*전체 학생</Label>
        <Box display="flex" alignItems="baseline" justifyContent="flex-end" flex="1">
          <InputBoxOnChange value={!total_cnt || total_cnt === 0 ? '' : total_cnt} onChange={(e)=>setField('total_cnt',e.target.value)} type='number'/>
          <Label paddingLeft='10px'>명</Label>
        </Box>
      </NumberInputContainer>
      <NumberInputContainer>
        <Label minWidth='110px'>*참여자</Label>
        <Box display="flex" alignItems="baseline" justifyContent="flex-end" flex="1">
          <InputBoxOnChange value={!attendee_cnt || attendee_cnt === 0 ? '' : attendee_cnt ?? ''} onChange={(e)=>setField('attendee_cnt',e.target.value)} type='number' isValid={isAttendeeValid}/>
          <Label paddingLeft='10px'>명</Label>
        </Box>
      </NumberInputContainer>
        {attendee_cnt !== 0 &&
          (isAttendeeValid ? 
            <></>
            :
            <AlertSpan $isValid={false}>참여자 수가 전체 학생 수보다 많습니다.</AlertSpan>
          )
        }
      <Box flex={1} display='flex'flexDirection={'column'}>
        <Label>메모</Label>
        <LargeTextField fullWidth onChange={(e)=>setField('content',e.target.value)} multiline rows={7} placeholder="" />
      </Box>
      <ButtonContainer>
        <NextButton style={{background:'#F5F5F5', color:'#7F7F89', minWidth:'90px', width:'90px', boxShadow:'none'}} onClick={() => setTab('home')}>취소</NextButton>
        <ButtonResultAdd setTab={setTab}/>
      </ButtonContainer>
    </Container>
  ); 
};

export default PromoResultAdd;